import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {FormGroup,Validators,FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import{PasswordValidation} from '../password-validation'
// import {IMyDpOptions, IMyDateModel} from 'angular4-datepicker/src/my-date-picker/interfaces';
import {HomeComponent} from '../home/home.component';
import {DatePipe} from '@angular/common';
declare var $:any;
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  userId:number=-1;
  profileForm:FormGroup;
  passwordForm:FormGroup;
  userProfileData:any[]=[];
  themeData:any[]=[];
  allThemeData:any[]=[];
  newThemeData:any[]=[];
  passwordModal:boolean=false;
  password:boolean=true;
  confirmPassword:boolean=true
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  myOptions={};
  companyId:number=-1;
  // public myDatePickerOptions: IMyDpOptions = {
  //      // other options...
  //      dateFormat: 'dd.mm.yyyy',
  //  };
  public myPlace: string = 'DOB';
  constructor(private service:DataService,private fb:FormBuilder,private route:ActivatedRoute,private home:HomeComponent) {
    this.profileForm=this.fb.group({
      'name':['',Validators.required],
      'phno':['',Validators.compose([Validators.required,Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])],
      'desig':[''],
      'dob':[''],
      'email':['',Validators.required],
      'org':[''],
      'dept':[''],
      'gender':[''],
      'themes':['']
    })
    this.passwordForm=this.fb.group({
      'password':['',Validators.required],
      'confirm-password':['',Validators.required],
    },{
      validator:PasswordValidation.MatchPassword
    })

  }

  ngOnInit() {
    this.companyId=sessionStorage.getItem("companyId")==null ? -1 : parseInt(sessionStorage.getItem("companyId"));
    // this.myOptions={
    //   altInput: true,
    //   altFormat: "F j, Y",
    //   dateFormat: "Y-m-d",
    // }
      $(window).scrollTop(0);
    this.getAllTheme();
      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"))
        $('div[id*="select-"]').remove();
      $('.cd-header').css('background-color','rgba(148,18,70,0.96)');
      this.route.params.subscribe(params=>{
        this.userId=params['id'];

          this.getUserDetailById();
      })
      this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
      this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));

  }

  ngDoCheck(){
      $('div[id*="select-"]').remove();
  }

  getUserDetailById(){
    const inputJson={
      "UserId":this.userId
    }
   // console.log(inputJson);

    if(this.userId==-1){
      return false;
    } else {
      this.service.GetUserDetailById(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.userProfileData=result['UserData'];
            this.fillProfileForm(this.userProfileData);
          }else{
            this.service.alertMessage(result['Message'],'error');
          }
        },
        (error)=>{
         // console.log(error);
        }
      )
    }
  }

  fillProfileForm(profileData){
   // console.log(profileData);
    if(profileData.length>0){
      let profile=profileData[0];
      this.myOptions={
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate:this.transformDateForFlatpickr(profile['DOB']),
        maxDate:"today"
      }
      sessionStorage.setItem('options',JSON.stringify(this.myOptions));
      this.service.storageSub.next('change');

      let selectedDate:any[]=[];
        this.themeData=profile['Themedata'];
        let myObj={};
        for(var i=0;i<this.themeData.length;i++){
          myObj={};
          myObj['ThemeId']=this.themeData[i]['ThemeIds'];
          myObj['Name']=this.themeData[i]['Name'];
          this.newThemeData.push(myObj);
        }
      if(profile['DOB']!=null && profile['DOB']!=''){


           selectedDate=profile['DOB'].split('.');
           selectedDate[1]=="1"
           this.profileForm.patchValue({
             'name':profile['UserName'],
             'phno':profile['MobileNo'],
             'desig':profile['UserRole'],
             'email':profile['Email'],
             'org':profile['OrganizationName'],
             'dept':profile['Department'],
             'gender':profile['Gender'],
             'themes':this.allThemeData,
           })


      } else {
        this.profileForm.patchValue({
          'name':profile['UserName'],
          'phno':profile['MobileNo'],
          'desig':profile['UserRole'],
          'email':profile['Email'],
          'org':profile['OrganizationName'],
          'dept':profile['Department'],
          'gender':profile['Gender'],
          'themes':this.allThemeData,
        })
      }




    }
  }

  getAllTheme(){
    this.service.GetAllTheme({'CompanyId':this.companyId})
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.allThemeData=result['AllThemeData'];
        }else{
          this.service.alertMessage(result['Message'],'error');
        }
      },
      (error)=>{
        console.log(error);
      }
    )
  }

  removeArea(index){
   // console.log(index);
   this.newThemeData.splice(index,1);
  }

  selectTheme(value){
    let filteredTheme=this.allThemeData.filter(theme=>theme.ThemeId==value);
    let myTheme=filteredTheme[0];
    if(this.newThemeData.length<5){
      let objectFound=this.newThemeData.filter(theme=>theme.ThemeId==value);
     // console.log("found "+objectFound);
      if(objectFound.length==0){
        this.newThemeData.push(myTheme);
      } else {
        this.service.alert(objectFound[0]['Name']+' already exists','error');
      }
    } else {
      this.service.alert('You can select max of 5 areas','error');
    }
  }

  toggleConfirmPassword(){
    this.confirmPassword=!this.confirmPassword;
  }

  togglePassword(){
    this.password=!this.password;
  }

  changePassword(form){
    const inputJson={
      "Pwd":form.value['password'],
	     "UserId":this.userId
    }
   // console.log(inputJson);
    if(this.userId==-1){
      return false;
    } else {
      this.service.ResetPassword(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.service.alert('Password changed successfully','success');
            this.passwordModal=false;
          }else{
            this.service.alert(result['Message'],'error');
          }
        },
        (error)=>{
         // console.log(error);
        }
      )
    }
  }

  updateProfile(form){
    if(!form.valid){
      if(!form.controls['name'].valid){
        this.service.alert('Please enter your name','error');
        return false;
      }

      if(!form.controls['phno'].valid){
        if(form.controls['phno'].hasError('required')){
          this.service.alert('Please enter your phone number','error')
        }else {
          this.service.alert('The format of your phone number is invalid','error')
        }
        return false;
      }


      if(!form.controls['email'].valid){
        if(form.controls['email'].hasError('required')){
          this.service.alert('Please enter your email','error')
        }else {
          this.service.alert('Invalid email format','error')
        }
        return false;
      }

    } else {
      if(this.newThemeData.length<3){
        this.service.alert('Please select atleast 3 areas','error');
        return false;
      }

      let themeArray:any[]=[];
      for(let theme of this.newThemeData){
        themeArray.push(theme['ThemeId']);
      }
      const inputJson={
      	"BornYear":form.controls['dob'].value,
      	"DepartMent":form.controls['dept'].value,
      	"Designation":form.controls['desig'].value,
      	"Gender":form.controls['gender'].value,
      	"Organization":form.controls['org'].value,
      	"Phone":form.controls['phno'].value,
      	"ThemeId":themeArray,
      	"UserId":this.userId
      }
     // console.log(inputJson);
      this.service.UpdateUserDetails(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.service.alert('Your profile has been updated successfully','success')
          } else {
              this.service.alert(result['Message'],'error')
          }
        },
        (error)=>{
         // console.log(error);
        }
      )
    }
  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }

  transformDateForFlatpickr(value){
   var datePipe = new DatePipe("en-US");
   value = datePipe.transform(value, 'yyyy-MM-dd');
   return value;
 }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/profile/profile.component.ts